<template>
  <div class="container-spinner">
    <img src="@/assets/icons/Spinner.svg" alt="" class="spinner" />
    <img src="@/assets/icons/LogoDH.svg" alt="" class="logo" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "SpinnerDH",
});
</script>

<style scoped>
.container-spinner {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  z-index: 5;
}

.logo {
  height: 56px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.spinner {
  height: 120px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -190px;
  margin-top: -60px;
  -webkit-animation: rotate-center 3s ease-in-out infinite both;
  animation: rotate-center 3s ease-in-out infinite both;
}

@-webkit-keyframes rotate-center {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes rotate-center {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
